export default __webpack_public_path__ + "static/media/hero-level-7-bg.dcaaf53c.webp";